export default () => ({
  tenants: [],
  currentTenant: null,
  loading: false
})